import { BaseAPI } from "../client/src/runtime";
const TYPE_ADDED = "ADDED";
const TYPE_MODIFIED = "MODIFIED";
const TYPE_DELETED = "DELETED";
const TYPE_ERROR = "ERROR";
const JSON_CONTENT_TYPE = "application/json";
const PLAIN_TEXT_CONTENT_TYPE = "text/plain";
const INVALID_TYPE_MESSAGE = "Invalid Content-Type";
const UNKNOWN_EVENT_MESSAGE = "Unknown event type:";
export const EVENT_DATA = "data";
export const EVENT_PLAIN_TEXT = "plain";
export const EVENT_ERROR = "error";
export const EVENT_TIMEOUT = "timeout";
export const EVENT_TERMINATE = "terminate";
const EVENT_STRINGS = Object.freeze([
    EVENT_DATA,
    EVENT_PLAIN_TEXT,
    EVENT_ERROR,
    EVENT_TIMEOUT,
    EVENT_TERMINATE,
]);
export class WatchApi extends BaseAPI {
    constructor() {
        super(...arguments);
        this.data = [];
        this.eventListeners = {};
        this.requestController = new AbortController();
    }
    subscribeToStream(path, query) {
        this.getStream(path, query);
        return new Promise((resolve) => {
            resolve(this);
        });
    }
    abortStream() {
        this.requestController.abort();
    }
    on(eventName, callback) {
        if (!this.eventListeners[eventName]) {
            this.eventListeners[eventName] = [];
        }
        this.eventListeners[eventName].push(callback);
    }
    emit(eventName, eventData) {
        const listeners = this.eventListeners[eventName];
        if (listeners) {
            for (const listener of listeners) {
                listener(eventData);
            }
        }
    }
    processData(line) {
        const event = JSON.parse(line);
        const object = event.object;
        const index = this.data.findIndex((resource) => {
            var _a, _b;
            return ((_a = resource === null || resource === void 0 ? void 0 : resource.metadata) === null || _a === void 0 ? void 0 : _a.uid) === ((_b = object === null || object === void 0 ? void 0 : object.metadata) === null || _b === void 0 ? void 0 : _b.uid);
        });
        switch (event.type) {
            case TYPE_ADDED:
                this.data.push(object);
                break;
            case TYPE_DELETED:
                if (index >= 0) {
                    this.data.splice(index, 1);
                }
                break;
            case TYPE_MODIFIED:
                if (index >= 0) {
                    this.data[index] = object;
                }
                break;
            case TYPE_ERROR:
                this.emit(EVENT_ERROR, object);
                break;
            default:
                this.emit(EVENT_ERROR, {
                    message: `${UNKNOWN_EVENT_MESSAGE} ${event.type}`,
                });
                break;
        }
        this.emit(EVENT_DATA, this.data);
    }
    findLine(buffer, fn) {
        const newLineIndex = buffer.indexOf("\n");
        if (newLineIndex === -1) {
            return buffer;
        }
        const chunk = buffer.slice(0, newLineIndex);
        const newBuffer = buffer.slice(newLineIndex + 1);
        fn(chunk);
        return this.findLine(newBuffer, fn);
    }
    getStream(path, query) {
        const response = this.request({
            path,
            method: "GET",
            headers: {},
            query,
        }, {
            signal: this.requestController.signal,
        });
        return response
            .then((res) => {
            switch (res.headers.get("Content-Type")) {
                case JSON_CONTENT_TYPE:
                    this.processJson(res);
                    break;
                case PLAIN_TEXT_CONTENT_TYPE:
                    this.processPlainText(res);
                    break;
                default:
                    this.emit(EVENT_ERROR, { message: INVALID_TYPE_MESSAGE });
            }
        })
            .catch((error) => {
            if (error.response) {
                error.response.json().then((errorData) => {
                    this.emit(EVENT_ERROR, errorData);
                });
            }
            else {
                this.emit(EVENT_ERROR, error);
            }
        });
    }
    processPlainText(res) {
        const stream = res.body.getReader();
        const utf8Decoder = new TextDecoder("utf-8");
        let buffer = "";
        const onIncomingStream = ({ value }) => {
            buffer += utf8Decoder.decode(value);
            const remainingBuffer = this.findLine(buffer, (line) => {
                try {
                    this.emit(EVENT_PLAIN_TEXT, line);
                }
                catch (error) {
                    throw new Error(error);
                }
            });
            buffer = remainingBuffer;
        };
        const terminateStream = () => {
            this.emit(EVENT_TERMINATE, { terminated: true });
        };
        return stream
            .read()
            .then(function callback({ done, value }) {
            if (done) {
                terminateStream();
                return;
            }
            onIncomingStream({ value });
            return stream.read().then(callback);
        })
            .catch((error) => {
            if (error.response) {
                error.response.json().then((errorData) => {
                    this.emit(EVENT_ERROR, errorData);
                });
            }
            else {
                this.emit(EVENT_ERROR, error);
            }
        });
    }
    processJson(res) {
        const stream = res.body.getReader();
        const utf8Decoder = new TextDecoder("utf-8");
        let buffer = "";
        const onIncomingStream = ({ value }) => {
            buffer += utf8Decoder.decode(value);
            const remainingBuffer = this.findLine(buffer, (line) => {
                try {
                    this.processData(line);
                }
                catch (error) {
                    throw new Error(error);
                }
            });
            buffer = remainingBuffer;
        };
        const terminateStream = () => {
            this.emit(EVENT_TERMINATE, { terminated: true });
        };
        return stream
            .read()
            .then(function callback({ done, value }) {
            if (done) {
                terminateStream();
                return;
            }
            onIncomingStream({ value });
            return stream.read().then(callback);
        })
            .catch((error) => {
            if (error.response) {
                error.response.json().then((errorData) => {
                    this.emit(EVENT_ERROR, errorData);
                });
            }
            else {
                this.emit(EVENT_TIMEOUT, error);
            }
        });
    }
}
